import { useHistory } from 'react-router-dom';

import { Button, Container } from 'react-bootstrap';

import styles from './Admin.module.css';

const Admin = () => {
  const history = useHistory();

  const usuarios = () => {
    history.push('/admin/usuarios');
  };

  const logs = () => {
    history.push('/admin/logs');
  };

  return (
    <Container>
      <div className={styles.button_container}>
        <Button variant='flat' className={styles.button} onClick={usuarios}>Usuários</Button>
        <Button variant='flat' className={styles.button} onClick={logs}>Logs</Button>
      </div>
    </Container>
  );
};

export default Admin;
